var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.label)?_c('FormLabel',_vm._b({},'FormLabel',{
      label: _vm.label,
      required: _vm.required,
      disabled: _vm.disabled,
      description: _vm.description,
      descriptionType: _vm.descriptionType,
      dirty: _vm.dirty,
      error: _vm.error,
      id: _vm.id,
      status: _vm.status
    },false)):_vm._e(),_c('FormList',{ref:"list",attrs:{"value":_vm.value,"disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var isRead = ref.isRead;
    var isEdit = ref.isEdit;
    var item = ref.item;
    var index = ref.index;
    var updateItem = ref.updateItem;
return [_c('SchemaForm',{attrs:{"disabled":_vm.disabled || isRead,"value":item,"fields":_vm.fields},on:{"input":function($event){return updateItem(index, $event)}}})]}}])}),(!_vm.disabled)?_c('AppButton',{on:{"click":_vm.add}},[_c('AppIcon',{attrs:{"name":"add"}}),_c('span',[_vm._v("Add Career Path")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }